import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import toast from "react-hot-toast";
import { handleError } from "../../../utils/handleError";
import {
  getAnswersOfUser,
  saveAnswers,
} from "../../../services/rest/users/medicalQuestions";
import Loading from "../../Loading/Loading";
import WbTwilightIcon from "@mui/icons-material/WbTwilight";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import Brightness6Icon from "@mui/icons-material/Brightness6";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import TerrainIcon from "@mui/icons-material/Terrain";
import EditRoadIcon from "@mui/icons-material/EditRoad";
import GrassIcon from "@mui/icons-material/Grass";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import RouteIcon from "@mui/icons-material/Route";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { useSelector } from "react-redux";

const PreferencesUser = ({ preferences, setAnswers }) => {
  const { _id } = useSelector((state) => state.userReducer);

  const initialDataListSchedule = {
    item: preferences?.horario ?? "Horario",
    icon:
      preferences?.horario === "Matutino" ? (
        <WbSunnyIcon />
      ) : preferences?.horario === "Tarde" ? (
        <Brightness6Icon />
      ) : preferences?.horario === "Noche" ? (
        <NightsStayIcon />
      ) : (
        <WbTwilightIcon />
      ),
  };
  const listDataSchedule = [
    {
      item: "Matutino",
      icon: <WbSunnyIcon />,
    },
    {
      item: "Tarde",
      icon: <Brightness6Icon />,
    },
    {
      item: "Noche",
      icon: <NightsStayIcon />,
    },
  ];
  const initialDataListTerrain = {
    item: preferences?.terreno ?? "Terreno",
    icon:
      preferences?.terreno === "Asfalto" ? (
        <EditRoadIcon />
      ) : preferences?.terreno === "Natural" ? (
        <GrassIcon />
      ) : preferences?.terreno === "Pista" ? (
        <AddRoadIcon />
      ) : (
        <TerrainIcon />
      ),
  };
  const listDataTerrain = [
    {
      item: "Asfalto",
      icon: <EditRoadIcon />,
    },
    {
      item: "Natural",
      icon: <GrassIcon />,
    },
    {
      item: "Pista",
      icon: <AddRoadIcon />,
    },
  ];

  const listDataDistance = [
    {
      item: "2-5 Km",
      icon: <RouteIcon />,
    },
    {
      item: "5-10 Km",
      icon: <RouteIcon />,
    },
    {
      item: "10-15 Km",
      icon: <RouteIcon />,
    },
  ];
  const initialDistance = {
    item: preferences?.distancia ?? "2-5 Km",
    icon: <RouteIcon />,
  };
  const [selectedItemSchedule, setSelectedItemSchedule] = useState(
    initialDataListSchedule
  );
  const [selectedTerrain, setSelectedTerrain] = useState(
    initialDataListTerrain
  );
  const [selectedDistance, setSelecetdDistance] = useState(initialDistance);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const answersFormat = {
        section: "preferencias",
        userAnswers: {
          horario: selectedItemSchedule?.item,
          terreno: selectedTerrain?.item,
          distancia: selectedDistance?.item,
        },
      };
      await saveAnswers(answersFormat);
      // console.log(response);
      const responseAnswers = await getAnswersOfUser(_id);
      console.log("responses", responseAnswers);
      setAnswers(responseAnswers ?? {});
      setLoading(false);
      toast.success("Se guardaron con éxito sus respuestas");
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se pudo guardar sus respuestas. \n ${message}`
      );
      setLoading(false);
    }
  };

  const CustomAccordion = ({ listData, selectedItem, setSelectedItem }) => {
    return (
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <ListItemIcon>{selectedItem.icon}</ListItemIcon>
            <Typography>{selectedItem.item}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {listData.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => setSelectedItem(item)}
                  sx={{
                    backgroundColor:
                      selectedItem.item === item.item
                        ? "rgba(212, 216, 216, 0.32)"
                        : "inherit",
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.item} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </Paper>
    );
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: "black", color: "white" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
          <ChecklistIcon sx={{ mr: 1 }} />
          <Typography variant="h6">Preferencias</Typography>
        </Box>
      </AppBar>
      <Loading loading={loading} />
      <Container sx={{ py: 4, flex: 1 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box>
              <Typography variant="body1">
                Seleccione su horario preferiado para Entrenar
              </Typography>
              <CustomAccordion
                listData={listDataSchedule}
                selectedItem={selectedItemSchedule}
                setSelectedItem={setSelectedItemSchedule}
              />
            </Box>
            <Box>
              <Typography variant="body1">
                Seleccione su Terreno preferiado para Entrenar
              </Typography>
              <CustomAccordion
                listData={listDataTerrain}
                selectedItem={selectedTerrain}
                setSelectedItem={setSelectedTerrain}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
            <Box sx={{ width: 210 }}>
              <Typography variant="body1" gutterBottom>
                Seleccione su Distancia Máxima Recorrida
              </Typography>
              <CustomAccordion
                listData={listDataDistance}
                selectedItem={selectedDistance}
                setSelectedItem={setSelecetdDistance}
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ backgroundColor: "#e7ef7d", width: "100%" }}
              >
                Guardar
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PreferencesUser;
